import { createClient } from "@supabase/supabase-js";
import type { Database } from "../types/database";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() ?? "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ?? "";

export const supabaseConfig = {
  url: supabaseUrl,
  anonKey: supabaseAnonKey,
  isConfigured: Boolean(supabaseUrl && supabaseAnonKey),
};

export const supabase = createClient<Database>(
  supabaseConfig.isConfigured ? supabaseUrl : "https://placeholder.supabase.co",
  supabaseConfig.isConfigured ? supabaseAnonKey : "placeholder-anon-key",
  {
    auth: {
      autoRefreshToken: true,
      detectSessionInUrl: true,
      persistSession: true,
      storageKey: "coachgrid-auth",
    },
  },
);

export function assertSupabaseConfigured() {
  if (!supabaseConfig.isConfigured) {
    throw new Error(
      "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Add them to your environment before using auth.",
    );
  }
}
